import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();
  const foundingYear = 2017;
  const displayYear = currentYear === foundingYear ? `${foundingYear}` : `${foundingYear}–${currentYear}`;

  return (
    <footer className="bg-gray-100 text-gray-700 text-sm mt-16">
      <div className="max-w-7xl mx-auto px-4 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Left: Brand Info */}
        <div className="text-center md:text-left">
          <p className="font-semibold text-gray-900 text-base">Badami Labs</p>
          <p className="text-gray-500 mt-1">Empowering ideas through software.</p>
        </div>

        {/* Center: Navigation Links */}
        <nav className="flex gap-6 flex-wrap justify-center md:justify-center">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <Link to="/about" className="hover:text-blue-600 transition">About</Link>
          <Link to="/services" className="hover:text-blue-600 transition">Services</Link>
          <Link to="/contact" className="hover:text-blue-600 transition">Contact</Link>
        </nav>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 mt-6">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-gray-400 text-xs">
          © {displayYear} Badami Labs. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
